import tw, { styled } from 'twin.macro';

export const TooltipContent = styled.div`
  ${tw`hidden absolute text-white text-center bg-black py-1 px-2`};
  top: calc(-100% - 10px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;

  &::after {
    content: '';
    position: absolute;
    border-width: 8px;
    border-color: black;
    bottom: -6px;
    left: 50%;
    transform: rotate(45deg) translateX(-50%);
    z-index: -1;
  }
`;

export const Container = styled.div`
  ${tw`relative`}

  width: fit-content;

  &:hover {
    ${TooltipContent} {
      display: block;
    }
  }
`;
